enum PaymentMethodType {
  OnlineGateway = 1,
  Wallet = 2,
  DirectDeposit = 3,
}
export enum PaymentMethodProviderType {
  Jibit = 1,
  Sepal = 2,
  Reseller = 3,
}

export enum DepositMethodType {
  OnlineGateway = 1,
  DirectDeposit = 3,
}

export default PaymentMethodType;
